import { CarePlanTypeEnum } from '../../Enum/CarePlanTypeEnum';
import { PlanStatusEnum } from '../../Enum/PlanStatusEnum';
import BaseEntity from '../BaseEntity.model';
import { CreatedBy } from '../Shared/CreatedBy.model';
import { PlanItem } from './PlanItem.model';

export interface IBehaviorOrSafetyPlan extends BaseEntity {
    CarePlanType: CarePlanTypeEnum;
    MemberId: string;
    Name: string;
    CreatedBy: CreatedBy;
    CreatedAt: string;
    UpdatedBy: CreatedBy;
    UpdatedAt: string;
    // All possible plan sections
    Behaviors: PlanItem[];
    Triggers: PlanItem[];
    WarningSigns: PlanItem[];
    Strategies: PlanItem[];
    PositiveDistractions: PlanItem[];
    People: PlanItem[];
    Agencies: PlanItem[];
    Environments: PlanItem[];
    Avoids: PlanItem[];
    MostImportant: string;
    Status: PlanStatusEnum;
    DeclinedAt: string;
    DeclinedBy: CreatedBy;
    DeclinedReason: string;
    ReviewedAt: string | null;
    ReviewedBy: CreatedBy | null;
}

export class BehaviorOrSafetyPlan implements IBehaviorOrSafetyPlan {
    Id: string;
    CarePlanType: CarePlanTypeEnum;
    MemberId: string;
    Name: string;
    CreatedBy: CreatedBy;
    CreatedAt: string;
    UpdatedBy: CreatedBy;
    UpdatedAt: string;
    Behaviors: PlanItem[];
    Triggers: PlanItem[];
    WarningSigns: PlanItem[];
    Strategies: PlanItem[];
    PositiveDistractions: PlanItem[];
    People: PlanItem[];
    Agencies: PlanItem[];
    Environments: PlanItem[];
    Avoids: PlanItem[];
    MostImportant: string;
    Status: PlanStatusEnum;
    DeclinedAt: string;
    DeclinedBy: CreatedBy | null;
    DeclinedReason: string;
    ReviewedAt: string | null;
    ReviewedBy: CreatedBy | null;

    constructor() {
        this.Id = '';
        this.CarePlanType = CarePlanTypeEnum.SafetyPlan;
        this.MemberId = '';
        this.Name = '';
        this.CreatedBy = new CreatedBy();
        this.CreatedAt = '';
        this.UpdatedBy = new CreatedBy();
        this.UpdatedAt = '';
        this.Behaviors = [];
        this.Triggers = [];
        this.WarningSigns = [];
        this.Strategies = [];
        this.PositiveDistractions = [];
        this.People = [];
        this.Agencies = [];
        this.Environments = [];
        this.Avoids = [];
        this.MostImportant = '';
        this.Status = PlanStatusEnum.NotStarted;
        this.DeclinedAt = '';
        this.DeclinedBy = null;
        this.DeclinedReason = '';
        this.ReviewedAt = null;
        this.ReviewedBy = null;
    }
}
